module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Italic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Italic.ttf
// module id = 49
// module chunks = 8